// extracted by mini-css-extract-plugin
export default {"info":"LabelInfo_info__NmWpF"};